import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import UserRoleModel from "../../models/user-role";

export default class UserRoleRepository extends BaseRepository {
  static modelClass = UserRoleModel;
  modelName = "user-role";
}
